// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mogc","icon":"styles_icon__1Ncl5"};